import React, { Component } from "react";
import { FormControl, FormGroup, Button, InputGroup } from "react-bootstrap";
import { toastr } from "react-redux-toastr";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { update } from "../utils/apiService";

// actions
import { updateVideo } from "../actions";

class VideoStateChooser extends Component {
  constructor() {
    super();

    this.state = {
      data_state: ""
    };

    this.handleChange = this.handleChange.bind(this);
    this.save = this.save.bind(this);
  }
  componentWillMount() {
    const { video } = this.props;
    this.setState({
      data_state: video.data_state
    });
  }
  handleChange(e) {
    this.setState({
      data_state: e.target.value
    });
  }
  save() {
    const { video, updateVideo } = this.props;
    let url = `/campaigns/${video.campaign_id}/videos/${video.id}`;
    let newStateDate = this.state.data_state;
    let data = {
      video: {
        data_state: newStateDate
      }
    };
    update(url, data)
      .then(res => {
        let updatedVideo = res.data;
        updateVideo(video.campaign_id, updatedVideo);
        toastr.success("data_state atualizado com sucesso!");
      })
      .catch(err => {
        toastr.error("Ocorreu um erro. Tente novamente.");
      });
  }
  render() {
    const { video } = this.props;
    return (
      <div>
        <FormGroup>
          <InputGroup>
            <FormControl
              type="text"
              value={this.state.data_state}
              placeholder="Digite o nome do data_state"
              onChange={this.handleChange}
            />
            <InputGroup.Button>
              <Button bsStyle="primary" onClick={this.save}>
                Salvar
              </Button>
            </InputGroup.Button>
          </InputGroup>
        </FormGroup>
        <p>Últimos data states usados:</p>
        <p>
          {video.data_state_history.map(name => (
            <span>
              <code>{name}</code>&nbsp;
            </span>
          ))}
        </p>
      </div>
    );
  }
}

VideoStateChooser.propTypes = {
  video: PropTypes.object,
  updateVideo: PropTypes.func
};

const mapDispatchToProps = dispatch => {
  return {
    updateVideo: (campaignId, video) => {
      dispatch(updateVideo(campaignId, video));
    }
  };
};

export default connect(null, mapDispatchToProps)(VideoStateChooser);



// WEBPACK FOOTER //
// ./src/components/VideoStateChooser.js